import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowDown = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 13,
	height: 13,
	viewBox: "0 0 13 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_19330_193901)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M5.94693 11.9643C5.8824 11.9323 5.81956 11.8971 5.75865 11.8587C5.70233 11.8234 5.65005 11.782 5.60275 11.7352L2.11063 8.22629C2.00466 8.13259 1.92315 8.01445 1.87318 7.88212C1.82485 7.75657 1.79966 7.6233 1.79883 7.48877C1.79883 7.35686 1.82281 7.22614 1.87318 7.09543C1.92315 6.96309 2.00466 6.84495 2.11063 6.75125C2.20708 6.6511 2.32302 6.57177 2.45131 6.51814C2.5796 6.46452 2.71751 6.43774 2.85654 6.43945C3.14555 6.43945 3.38899 6.54379 3.58567 6.75125L5.29096 8.45654V1.89681C5.29096 1.603 5.39529 1.35356 5.60275 1.15209C5.69907 1.05466 5.81399 0.977587 5.94069 0.925465C6.06739 0.873342 6.20328 0.847233 6.34027 0.848691C6.63528 0.848691 6.88472 0.949425 7.08619 1.15209C7.28766 1.35476 7.38959 1.603 7.38959 1.89801V8.45654L9.09488 6.75125C9.19133 6.6511 9.30728 6.57177 9.43557 6.51814C9.56385 6.46452 9.70176 6.43774 9.8408 6.43945C10.131 6.43945 10.3792 6.54379 10.5867 6.75125C10.7942 6.95872 10.8985 7.20695 10.8985 7.49717C10.9011 7.63385 10.8747 7.76953 10.8209 7.89522C10.7672 8.02092 10.6873 8.13376 10.5867 8.22629L7.09458 11.7352C7.04115 11.7781 6.98636 11.8193 6.93029 11.8587C6.87299 11.8982 6.81286 11.9335 6.75041 11.9643H6.73362C6.60733 12.0089 6.47422 12.0312 6.34027 12.0302C6.27437 12.0301 6.20858 12.0244 6.1436 12.0134C6.0821 12.0039 6.02179 11.9878 5.96372 11.9655L5.94693 11.9643Z",
			fill: "#F96155"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_19330_193901",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 11.9922,
			height: 11.9922,
			fill: "white",
			transform: "translate(0.599609 0.592773)"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgArrowDown);
export default ForwardRef;
